import { COLORS, pickThemeFontStyles, GRADIENTS } from '@/theme';
import { Button } from '@/ui';
import styled from 'styled-components';

export const StyledActionButton = styled(Button)`
  &&& {
    background: ${COLORS.RED};
    padding: 0.25rem;
    border: none;
    max-width: 7.125rem;
    min-width: 2.125rem;
    height: 2.125rem;
    color: ${COLORS.WHITE};
    ${pickThemeFontStyles('12', '14', 'BOLD')};

    :hover {
      background: ${COLORS.RED};
    }
  }

  svg {
    path {
      fill: ${COLORS.WHITE};
    }
  }
`;

export const StyledLink = styled.a`
  &&& {
    cursor: pointer;
    text-decoration: underline;
    display: block;
    max-width: 100%;
  }
`;

export const StyledNameWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  align-items: flex-start;
`;

export const StyledCustomOrderBadge = styled.div`
  background: ${GRADIENTS.BLUE};
  ${pickThemeFontStyles('10', '26', 'NORMAL')};
  color: ${COLORS.WHITE};
  border-radius: 1.6rem;
  padding: 0 0.75rem;
`;

export const StyledDeletedText = styled.div`
  ${pickThemeFontStyles('10', '26', 'NORMAL')};
  color: ${COLORS.RED};
`;

export const StyledSupplierWrapper = styled.span`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex-wrap: wrap;
`;

export const StyledSupplierBock = styled.span`
  font-size: 0.875rem;
  color: ${COLORS.IRON_GRAY};
`;

export const StyledSupplierName = styled.span`
  font-size: 1rem;
  color: ${COLORS.BLACK_PRIMARY};
`;

export const StyledPartnerConfirmationInfo = styled.span<{ $isConfirmed: boolean }>`
  margin-left: 0.5rem;
  ${pickThemeFontStyles('12', '16', 'NORMAL')};
  color: ${({ $isConfirmed }) => ($isConfirmed ? COLORS.GREEN : COLORS.NORMAL_GRAY)};
`;
